import { render, staticRenderFns } from "./delivered-reject-reason.vue?vue&type=template&id=36c46752"
import script from "./delivered-reject-reason.vue?vue&type=script&lang=js"
export * from "./delivered-reject-reason.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports